/**
 * Mixin for checking user roles
 */
import Vue from "vue";
import { RoleNames } from "@/auth/RoleNames";

export default Vue.extend({
  data: () => {
    return {};
  },
  computed: {
    isObjectsReadAllowed(): boolean {
      return this.$root.$data.user && this.checkRoles(RoleNames.OBJECTS_READ);
    },
    isObjectsWriteAllowed(): boolean {
      return this.$root.$data.user && this.checkRoles(RoleNames.OBJECTS_WRITE);
    },
    isAdmin(): boolean {
      return this.$root.$data.user && this.checkRoles(RoleNames.ADMIN);
    }
  },
  methods: {
    checkRoles(...roles: string[]): boolean {
      return this.$auth.checkUserRoles(...roles);
    }
  }
});
